
export { ShoppingBagButton } from "/codebuild/output/src3146945838/src/packages/shared-components/src/components/ShoppingBagButton/index.ts"